import { Link } from "react-router-dom";
import type { VideoItem } from "@/mocks/videos";
import { formatCount, formatRelativeDate } from "@/lib/format";

interface LatestStripProps {
  videos: VideoItem[];
}

export default function LatestStrip({ videos }: LatestStripProps) {
  return (
    <section className="w-full">
      <div className="flex items-end justify-between mb-5">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2">
            <i className="ri-flashlight-line text-accent-500"></i>
            最新上传
          </h2>
          <p className="text-sm text-foreground-500 mt-1">实时更新，第一时间发现新鲜内容</p>
        </div>
        <span className="hidden sm:flex items-center gap-1 text-xs text-foreground-400">
          <i className="ri-refresh-line"></i>
          持续更新中
        </span>
      </div>

      <div className="flex gap-4 overflow-x-auto no-scrollbar pb-2 -mx-4 px-4 md:mx-0 md:px-0">
        {videos.map((video) => (
          <Link
            key={video.id}
            to={`/detail/${video.id}`}
            className="group w-[220px] md:w-[240px] shrink-0 flex flex-col bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-accent-300 transition-all duration-300 cursor-pointer"
          >
            <div className="relative w-full aspect-video overflow-hidden bg-background-200">
              <img
                src={video.cover}
                alt={video.title}
                title={`${video.title} - 快手短视频`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-foreground-950/75 text-background-50 text-xs">
                {video.duration}
              </span>
              <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs">
                {video.categoryName}
              </span>
            </div>
            <div className="p-3">
              <h3 className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-accent-600 transition-colors">
                {video.title}
              </h3>
              <div className="flex items-center justify-between mt-2 text-xs text-foreground-400">
                <span className="line-clamp-1">{video.author}</span>
                <span className="flex items-center gap-1 shrink-0">
                  <i className="ri-play-circle-line"></i>
                  {formatCount(video.views)}
                </span>
              </div>
              <p className="text-xs text-foreground-400 mt-1">{formatRelativeDate(video.publishDate)}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}